import styled from 'styled-components';
import { unthemed } from 'tokens';
export const Base = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
`;

export const ScrollingArea = styled.div`
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 14px;
	scrollbar-width: thin;
	&::-webkit-scrollbar {
		width: 8px;
	}
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};
`;

export const Comment = styled.div<{ $resolved?: boolean; $isReply?: boolean }>`
	position: relative;
	min-width: 0; /* allow shrinking inside flex column so long content doesn't push width */
	padding: 8px 10px;
	background-color: ${({ theme }) => theme.gray[100]};
	border-radius: 6px;
	opacity: ${({ $resolved }) => ($resolved ? 0.55 : 1)};

	&:hover [data-comment-actions],
	&:focus-within [data-comment-actions] {
		opacity: 1;
	}
`;

export const ElementChip = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 3px;
	padding: 2px 6px;
	border-radius: 10px;
	background-color: ${({ theme }) => theme.blue[900]};
	color: ${({ theme }) => theme.blue[500]};
	font-size: 10px;
	font-weight: 500;
	flex-shrink: 0;

	&:hover {
		background-color: ${({ theme }) => theme.blue[700]};
	}
`;

export const ResolvedBadge = styled.div`
	padding: 2px 6px;
	border-radius: 10px;
	background-color: ${({ theme }) => theme.green[200]};
	color: ${({ theme }) => theme.green[800]};
	font-size: 10px;
	font-weight: 500;
	flex-shrink: 0;
`;

export const Actions = styled.div`
	position: absolute;
	top: 8px;
	right: 8px;
	display: flex;
	gap: 2px;
	padding: 3px;
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
	opacity: 0;
	transition: opacity 0.12s ease;
	z-index: 1;
`;

export const ActionButton = styled.button`
	background: transparent;
	border: none;
	padding: 4px;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme }) => theme.gray[700]};

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
		color: ${({ theme }) => theme.gray[1000]};
	}
`;

export const EditActions = styled.div`
	display: flex;
	gap: 6px;
	margin-top: 8px;
	justify-content: flex-end;
`;

export const EditButton = styled.button`
	background: transparent;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	padding: 4px 10px;
	border-radius: 4px;
	font-size: 11px;
	color: ${({ theme }) => theme.gray[900]};

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
	}
`;

export const CommentHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
`;

export const UserInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const UserInitial = styled.div`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: 14px;
	color: ${unthemed.gray[100]};
	text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4), 0 -2px 4px rgba(0, 0, 0, 0.4);
	border: 2px solid ${({ theme }) => theme.gray[200]};
`;

export const UserId = styled.div`
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[900]};
	min-width: 0;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Timestamp = styled.div`
	margin-left: 6px;
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
	white-space: nowrap;
	flex-shrink: 0;
`;

export const CommentContent = styled.div`
	font-size: 13px;
	line-height: 18px;
	color: ${({ theme }) => theme.gray[1000]};
	overflow-x: hidden;

	// Markdown styles
	p {
		margin: 0 0 8px 0;
		&:last-child {
			margin-bottom: 0;
		}
	}

	code {
		background-color: ${({ theme }) => theme.gray[200]};
		padding: 2px 4px;
		border-radius: 4px;
		font-size: 12px;
	}

	pre {
		background-color: ${({ theme }) => theme.gray[100]};
		padding: 8px;
		border-radius: 4px;
		overflow-x: auto;
		margin: 8px 0;
	}
`;

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	text-align: center;
`;

export const EmptyStateIcon = styled.div`
	margin-bottom: 16px;
	opacity: 0.6;
`;

export const EmptyStateText = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[700]};
	margin-bottom: 4px;
`;

export const EmptyStateSubtext = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
`;
